import React, { useState, useEffect } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import jsPDF from "jspdf";
import moment from "moment";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { Button, Container, Grid, styled, Table } from "@mui/material";
import { TableBody, TableCell, TableContainer, TableHead } from "@mui/material";
import { TableRow, Dialog, DialogContent, TextField } from "@mui/material";
import dustbin from "../../images/dustbin.png";
import { Stack } from "@mui/system";
import PurchaseRepository from "../../Repository/PurchaseRepository";
import { deletePurchase } from "./httpCalls";
import DeleteDialog from "../reusableComponents/DeleteDialog";
import UpdateDate from "./UpdateDate";
import { BodyContainer, HeaderTitle, Header } from "../../pages/bank/styles";
import { BtnCancel } from "../styles";
import billImg from "../../images/bill.png";
const customStyles = {
  rows: {
    style: {
      minHeight: "60px",
      background: "white",
      padding: "2px 10px",
      marginTop: "5px",
    },
  },
  header: {
    style: {
      color: "#4EAF50",
    },
  },
  headCells: {
    style: {
      backgroundColor: "#4EAF50",
      color: "white",
      fontSize: "16px",
    },
  },
  cells: {
    style: {
      paddingLeft: "18px",
    },
  },
  table: {
    style: {
      background: "#EBEBEB",
      marginBottom: "20px",
    },
  },
};

const Preview = styled("div")({
  position: "relative",
  zoom: 1,
  minWidth: "235mm",
  maxWidth: "235mm",
  minHeight: "150mm",
  maxHeight: "maxContent",
  backgroundColor: "white",
  padding: "10px",
});

const CommentSection = styled("div")({
  position: "relative",
  width: "40%",
  height: "150px",
  border: "2px solid #cecdcd",
});
const CommentTitle = styled("div")({
  margin: "0px",
  padding: "2px",
  backgroundColor: "#cecdcd",
  width: "100%",
});
const SubTitle = styled(Typography)({
  padding: "2px 10px 2px 10px",
  backgroundColor: "#4caf50",
  color: "white",
  width: "450px",
  margin: "5px 0px",
});

function FinalizedOrders() {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const [state, setState] = useState({
    loading: false,
    data: [],
    orders: [],
    order: {},
    showOrder: false,
    Total: 0,
    updateDialog: false,
    maxWidth: "md",
    modal: false,
    vendorSearch: "",
    indexSearch: "",
    deleteModal: false,
    resetPaginationToggle: false,
    nextToken: "",
    toggleImgModal:false
  });
  console.log("stateeee", state)

  const columns = [
    {
      name: "#",
      width: "100px",
      selector: (row) => (row?.purchaseNumber ? row?.purchaseNumber : "EMPTY"),
    },
    {
      name: "Print",
      width: "100px",
      selector: (row) => (  
      <img
      src={billImg}
      style={{ cursor: "pointer" }}
      height="50px"
      onClick={() => toggle(row)}
      />

    ),
   
    },
    {
      name: "Item",
      width: "300px",
      selector: (row) => row.items.map((item) => item.name),
    },
    {
      name: "Paid Price(Cost)",
      selector: (row) =>
        row.new_paid
          ? Number(row.paid) + Number(row.new_paid)
          : Number(row.paid),
    },
    {
      name: "Ledger Name",
      selector: (row) => row.ledger_detail?.name,
    },
    {
      name: "Date",
      selector: (row) => (
        <Typography onClick={() => openToggle(row)}>
          {moment.unix(row.created_at).format("DD-MM-YY hh:mm")}
        </Typography>
      ),
    },
    {
      name: "Actions",
      width: "120px",
      cell: (row) => (
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-evenly"
          width="100%"
        >
          <Link
            to={{
              pathname: "/inventory/admin/purchase-order/updatedOrder",
              state: {
                order: row,
                selectedToSale: row.items,
                date: moment.unix(row.created_at).format("YYYY-MM-DD"),
                user: row.ship,
                selectedVendor: row.vendor,
                selectedLedger: row.ledger != null ? row.ledger : "",
                ledger_detail:
                  row.ledger_detail != null && row.ledger_detail
                    ? row.ledger_detail
                    : "",
              },
            }}
          >
            <i style={{ cursor: "pointer" }} className=" fas fa-edit" />
          </Link>
          <img
            height="20px"
            src={dustbin}
            alt=""
            onClick={() => handleDelete(row)}
          />
        </Stack>
      ),
    },
  ];

  useEffect(() => {
    getOrders();
  }, []);

  const openToggle = (value = null) => {
    setOpen((prev) => !prev);
    setSelected(value);
  };

  const toggleImage = (row) => {
  
      setState((prev) => ({ ...prev,  toggleImgModal: !prev.modal }));
  
  };


  const toggle = (row) => {
    setState((prev) => ({
      ...prev,
      order: row, // Correctly assigns the passed `row` data
      modal: !prev.modal, // Toggles the modal state
    }));
  };
  
  const handleDelete = (row) => {
    setState((prev) => ({
      ...prev,
      selectedOrder: row,
      deleteModal: true,
    }));
  };

  const deleteRow = async () => {
    await deletePurchase(state.selectedOrder._id);
    setState((prev) => ({
      ...prev,
      deleteModal: false,
    }));
    getOrders();
  };

  // const getOrders = async (row="") => {
  //   setState((prev) => ({ ...prev, loading: true }));
  //   let { data } = await PurchaseRepository.purchasesModel({
  //     request: {
  //       method: "getPurchases",
  //       data: {
  //         company_code: localStorage.getItem("companyCode"),
  //         next_Token :state.nextToken,
  //       },
  //     },
  //   });
  //   console.log("data:", data);
  //   setState((prev) => ({
  //     ...prev,
  //     loading: false,
  //     data: data.response.data.purchases,
  //      nextToken:data.next_page_token

  //   }));
  // };

  const getOrders = async (page = 1) => {
    setState((prev) => ({ ...prev, loading: true }));

    try {
      const { data } = await PurchaseRepository.purchasesModel({
        request: {
          method: "getPurchases",
          data: {
            company_code: localStorage.getItem("companyCode"),
            next_page_token: state.nextToken,
          },
        },
      });

      setState((prev) => ({
        ...prev,
        loading: false,
        data:
          page === 1
            ? data.response.data.purchases
            : [...prev.data, ...data.response.data.purchases],
        nextToken: data.response.data.next_page_token,
        totalCount: data.response.data.totalCount, // Ensure this is from your API
        currentPage: page,
      }));
    } catch (error) {
      console.error("Error fetching orders:", error);
      setState((prev) => ({ ...prev, loading: false }));
    }
  };


  const totalPrice = () => {
    let total = 0;
    state.order?.items?.forEach((item) => {
      let qty = item.newQuantity ? parseInt(item.newQuantity) : 1;
      let itemPrice = item.newPrice
        ? parseInt(item.newPrice)
        : parseInt(item.companyPrice);

      total += itemPrice * qty;
    });

    return total;
  };

  const handleRow = (row) => {
    setState((prev) => ({ ...prev, order: row, modal: true }));
  };

  const print = () => {
    var doc = new jsPDF();
    // toggle();
    doc.setFontSize(18);
    doc.setFontStyle("bold");
    doc.text(localStorage.getItem("company"), 105, 22);
    doc.setFontSize(26);
    doc.text("PURCHASE ORDER", 105, 35);

    doc.setFontSize(12);
    doc.setFontStyle("normal");

    doc.text("Date:", 150, 45);
    doc.text(
      moment.unix(state.order?.created_at).format("DD-MM-YYYY"),
      165,
      45
    );

    doc.setFontSize(14);
    doc.setFontStyle("bold");
    doc.text("SHIP TO", 100, 48);

    doc.setFontSize(12);
    doc.setFontStyle("normal");
    doc.text(state?.order?.vendor?.dept || "", 20, 60);
    if (state?.order?.vendor) {
      let val1 = state.order?.vendor.companyName || state.order?.vendor.company;
      doc.text(val1, 20, 55);

      doc.text(state.order?.vendor.dept || "", 20, 60);
      doc.text(state.order?.vendor.street || "", 20, 65);
      doc.text(state.order?.vendor.city || "", 20, 70);
      doc.text(state.order?.vendor.phone || "", 20, 75);
      doc.text("VENDOR", 21, 48);
    } else {
      doc.text(state.order?.ledger_detail.name, 20, 55);
      doc.text(state.order?.ledger_detail.address, 20, 60);
      doc.text(state.order?.ledger_detail.ledgerType, 20, 65);
      doc.text("LEDGER", 21, 48);
    }

    var img = new Image();
    let baseUrl = localStorage.getItem("base_url");

    if (baseUrl == undefined || baseUrl == "" || baseUrl == null) {
      let snapshot = employeeLogo;
      img.src = snapshot;
    } else {
      let snapshot = localStorage.getItem("base_url");
      img.src = snapshot;
    }
    doc.addImage(img, "png", 0, 0, 40, 40);

    doc.text(state.order?.ship.name, 100, 55);
    doc.text(state.order?.ship.company, 100, 60);
    doc.text(state.order?.ship.street, 100, 65);
    doc.text(state.order?.ship.city, 100, 70);

    doc.setFontSize(14);
    doc.setFontStyle("bold");
    doc.text("#", 21, 90);
    doc.text("Item", 40, 90);
    doc.text("Quantity", 140, 90);
    doc.text("Price", 170, 90);

    doc.cell(20, 84, 170, 8, " ");

    let y = 92;

    state.order?.items?.map((item, index) => {
      doc.setFontSize(14);
      doc.setFontStyle("bold");
      doc.cell(20, y, 12, 6, " ");
      doc.cell(32, y, 130, 6, " ");
      doc.cell(137, y, 25, 6, " ");
      doc.cell(162, y, 28, 6, " ");

      doc.setFontSize(12);
      doc.setFontStyle("normal");
      doc.text((index + 1).toString(), 22, y + 5);
      doc.text(item.name, 34, y + 5);
      doc.text(
        item?.newQuantity ? item.newQuantity.toString() : "1",
        139,
        y + 5
      );
      doc.text(
        item.newPrice
          ? item?.newPrice.toString() || "0"
          : item?.companyPrice.toString() || "0",
        170,
        y + 5
      );

      doc.setFontSize(10);

      doc.text(
        localStorage.getItem("terms") != "undefined"
          ? localStorage.getItem("terms")
          : "",
        58,
        270
      );

      doc.text("Powered by www.hardwarepakistan.com", 68, 280);
      doc.text("0342-5588269", 88, 290);
      y = y + 6;

      if (y >= 240) {
        doc.addPage();
        y = 20;
      }
    });

    y = y + 8;

    doc.cell(20, y, 100, 8, " ");
    doc.cell(20, y + 8, 100, 30, " ");
    doc.setFontSize(14);
    doc.text("Comments Or Special Instructions", 22, y + 6);
    doc.text("SUB TOTAL", 138, y);
    doc.text(totalPrice().toString(), 168, y);

    doc.text("TAX", 138, y + 7);
    doc.text("SHIPPING", 138, y + 14);
    doc.text("OTHER", 138, y + 21);

    y = y + 23;

    doc.line(137, y, 190, y, "S");

    doc.text("TOTAL", 138, y + 6);
    doc.text(totalPrice().toString(), 168, y + 6);
    if (window.innerWidth <= 600) {
      doc.save("reciept");
    } else {
      doc.autoPrint();
    }
    window.open(doc.output("bloburl"), "_blank");
  };

  const handleInput = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setState((prev) => ({ ...prev, [name]: value }));
  };

  const subHeaderComponentMemo = () => {
    return (
      <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
        <TextField
          size="small"
          label="Search by Index"
          name="indexSearch"
          value={state.indexSearch}
          type="number"
          onChange={handleInput}
        />
        <TextField
          label="Search by Name/Cost"
          name="vendorSearch"
          size="small"
          value={state.vendorSearch}
          onChange={handleInput}
          sx={{ ml: 0.8 }}
        />
      </Box>
    );
  };

  const filtered = () => {
    if (state.indexSearch) {
      let found = state?.data.find(
        (item) => item?.purchaseNumber == state.indexSearch
      );
      if (found) {
        return [found];
      } else {
        return [];
      }
    } else if (state.vendorSearch) {
      let filteredItems = state?.data.filter((item) => {
        let name = item?.ledger_detail?.name?.toLowerCase();
        if (name.includes(state.vendorSearch)) {
          return item;
        }
      });
      return filteredItems;
    } else {
      return state.data;
    }
  };

  return (
    <Box>
      <Header>
        <HeaderTitle> </HeaderTitle>
        <HeaderTitle>Finalized Orders</HeaderTitle>
        <HeaderTitle> </HeaderTitle>
      </Header>
      <BodyContainer>
        {state.loading && (
          <Stack alignItems="center">
            <ClipLoader size={50} color="#4DAF51" loading={true} />
          </Stack>
        )}
        {/* {!state.loading && (
          <DataTable
            data={filtered()}
            columns={columns}
            highlightOnHover={true}
            pointerOnHover={true}
            // pagination={true}
            paginationResetDefaultPage={state.resetPaginationToggle}
            Clicked
            onRowClicked={(row) => handleRow(row)}
            subHeader
            subHeaderComponent={subHeaderComponentMemo()}
            customStyles={customStyles}
          />
        )} */}

        <DataTable
          data={state.data}
          columns={columns}
          highlightOnHover
          pointerOnHover
          pagination
          paginationServer
          paginationTotalRows={state.totalCount}
          onChangePage={(page) => getOrders(page)}
          subHeader
          subHeaderComponent={subHeaderComponentMemo()}
          customStyles={customStyles}
        />
      </BodyContainer>

      <DeleteDialog
        title="Delete Purchase"
        open={state.deleteModal}
        onClose={deleteRow}
        onClickYes={deleteRow}
      />
    

      <Dialog
        title="Purchase Details"
        fullWidth
        maxWidth="md"
        open={state.modal}
        onClose={toggle}
      >
        <DialogContent dividers={scroll === "paper"}>
          <Preview>
            <Container>
              <Stack direction="row" marginBottom="25px">
                <BtnCancel onClick={toggle}>Go Back</BtnCancel>
                <Button
                  variant="contained"
                  sx={{ textTransform: "none", ml: 1 }}
                  onClick={print}
                >
                  Print Reciept
                </Button>
              </Stack>

              <Grid container sx={{ justifyContent: "space-between" }}>
                <Grid item lg={6} md={6} sm={6}>
                  <Typography variant="h4" sx={{ color: "#4EAF51" }}>
                    {localStorage.getItem("company")}
                  </Typography>
                </Grid>

                <Grid item lg={5} md={5} sm={5}>
                  <Typography variant="h4" sx={{ color: "#4EAF51" }}>
                    PURCHASE ORDER
                  </Typography>
                  DATE :{" "}
                  {moment.unix(state.order?.created_at).format("DD-MM-YYYY")}
                </Grid>
              </Grid>
            </Container>
            <Grid
              container
              style={{ marginBottom: "30px", justifyContent: "space-between" }}
            >
              <Grid item lg={6} md={6} sm={6}>
                {state.order?.ledger_detail ? (
                  <>
                    <SubTitle>LEDGER</SubTitle>
                    <Typography variant="body1">
                      {state.order?.ledger_detail?.name}
                    </Typography>
                    <Typography variant="body1">
                      {state.order?.ledger_detail?.address}
                    </Typography>
                    <Typography variant="body1">
                      {state.order?.ledger_detail?.ledgerType}
                    </Typography>
                  </>
                ) : (
                  <>
                    <SubTitle>VENDOR</SubTitle>
                    <Typography variant="body1">
                      {state.order?.vendor?.company}
                    </Typography>
                    <Typography variant="body1">
                      {state.order?.vendor?.dept}
                    </Typography>
                    <Typography variant="body1">
                      {state.order?.vendor?.street}
                    </Typography>
                    <Typography variant="body1">
                      {state.order?.vendor?.city}
                    </Typography>
                    <Typography variant="body1">
                      {state.order?.vendor?.phone}
                    </Typography>
                  </>
                )}
              </Grid>
              <Grid item lg={6} md={6} sm={6}>
                <SubTitle>SHIP TO </SubTitle>
                <Typography variant="body1">
                  {state.order?.ship?.name}
                </Typography>
                <Typography variant="body1">
                  {state.order?.ship?.company}
                </Typography>
                <Typography variant="body1">
                  {state.order?.ship?.street}
                </Typography>
                <Typography variant="body1">
                  {state.order?.ship?.phone}
                </Typography>
              </Grid>
            </Grid>
            <TableContainer>
              <Table
                // sx={{ minWidth: 650 }}
                size="small"
                aria-label="customized table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell>#</TableCell>
                    <TableCell>Item</TableCell>
                    <TableCell>Description</TableCell>
                    <TableCell>Quantity</TableCell>
                    <TableCell>Price</TableCell>
                    <TableCell>Total Price</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {state.order?.items?.map((item, index) => {
                    let qty = item.newQuantity ? parseInt(item.newQuantity) : 1;
                    let itemPrice = item.newPrice
                      ? item.newPrice
                      : item.companyPrice;

                    return (
                      <TableRow key={index}>
                        <TableCell component="th">{index + 1}</TableCell>
                        <TableCell component="th">{item.name}</TableCell>
                        <TableCell component="th">{item.description}</TableCell>
                        <TableCell component="th">{qty}</TableCell>
                        <TableCell component="th">{itemPrice}</TableCell>
                        <TableCell component="th">{itemPrice * qty}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>

            <Stack
              direction="row"
              justifyContent="space-evenly"
              marginTop="50px"
              width="100%"
            >
              <CommentSection>
                <CommentTitle>
                  <Typography variant="body1">
                    Comments Or Special Instructions
                  </Typography>
                </CommentTitle>
              </CommentSection>
              <Stack direction="row" gap={5}>
                <Stack>
                  <p className="no-margin-padding">SUB TOTAL </p>
                  <p className="no-margin-padding">Tax </p>
                  <p className="no-margin-padding">SHIPPING </p>
                  <p className="no-margin-padding">OTHER</p>
                  <p className="no-margin-padding">TOTAL</p>
                </Stack>
                <Stack>
                  <p className="no-margin-padding">{totalPrice()}</p>
                  <p className="no-margin-padding">- </p>
                  <p className="no-margin-padding">- </p>
                  <p className="no-margin-padding">- </p>
                  <p className="no-margin-padding">{totalPrice()}</p>
                </Stack>
              </Stack>
            </Stack>
          </Preview>
        </DialogContent>
      </Dialog>

      {open && (
        <UpdateDate onClose={openToggle} row={selected} onSuccess={getOrders} />
      )}
    </Box>
  );
}

export default FinalizedOrders;
